module.exports = __webpack_public_path__ + "media/images/media-elements/minimize-e49579e631bc0776933290bdcfe17487.svg";